var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"story01"},[_c('div',{staticClass:"story01--con"},[_c('div',{staticClass:"story01--subtit"},[_c('div',{staticClass:"subtit-bold"},[_vm._v("Brand")]),_c('div',{staticClass:"subtit-light"},[_vm._v("Story")])]),_c('div',{staticClass:"story01--visual"})])])
}]

export { render, staticRenderFns }